import Locales from '@/Locales';
import '@/style/iconfont/iconfont.css';
import '@/style/mixin.less';
import '@/style/theme.less';
import { ConfigProvider, Spin } from '@sinohealth/butterfly-ui-components';
import '@sinohealth/butterfly-ui-components/lib/index.css';
import { Suspense, useEffect } from 'react';
import { AliveScope } from 'react-activation';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { RecoilRoot, useRecoilValue } from 'recoil';
import App from './App';
import { darkTheme, lightTheme } from './config/theme';
import { globalFontSizeAtom, themeMode } from './store/theme';

// 主题包装组件
const ThemeWrapper = ({ children }: { children: React.ReactNode }) => {
  const currentTheme = useRecoilValue(themeMode);
  const globalFontSize = useRecoilValue(globalFontSizeAtom);

  useEffect(() => {
    // 在 body 上设置主题属性
    // console.log('currentTheme', currentTheme);
    // console.log('globalFontSize', globalFontSize);
    document.body.setAttribute('data-theme', currentTheme);
  }, [currentTheme]);

  return (
    <ConfigProvider
      theme={
        currentTheme === 'dark'
          ? darkTheme
          : { ...lightTheme, token: { ...lightTheme.token, fontSize: globalFontSize } }
      }
    >
      {children}
    </ConfigProvider>
  );
};

const loading = (
  <div style={{ display: 'flex', height: '100vh' }}>
    <Spin size="large" style={{ margin: 'auto' }} />
  </div>
);

ReactDOM.render(
  <RecoilRoot>
    <Locales>
      <ThemeWrapper>
        <Suspense fallback={loading}>
          <HashRouter>
            <AliveScope>
              <App />
            </AliveScope>
          </HashRouter>
        </Suspense>
      </ThemeWrapper>
    </Locales>
  </RecoilRoot>,
  document.getElementById('root'),
);
